const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

function parseEmailField(raw) {
  if (!raw) return [];
  return raw
    .split(/[;,]/)
    .map(e => e.trim())
    .filter(e => e && EMAIL_REGEX.test(e));
}

export function buildRecipientOptions(person) {
  if (!person) return [];
  const invoiceEmails = parseEmailField(person.email);
  const generalEmails = parseEmailField(person.email_bis);

  const byEmail = new Map();
  const add = (email, source) => {
    const key = email.toLowerCase();
    const existing = byEmail.get(key);
    if (!existing) {
      byEmail.set(key, { email, sources: new Set([source]) });
    } else {
      existing.sources.add(source);
    }
  };
  invoiceEmails.forEach(e => add(e, 'invoice'));
  generalEmails.forEach(e => add(e, 'general'));

  return Array.from(byEmail.values()).map(({ email, sources }) => ({
    email,
    label: email,
    source: sources.has('invoice') && sources.has('general') ? 'both' : (sources.has('invoice') ? 'invoice' : 'general'),
  }));
}

export function pickDefaultRecipients(options, kind) {
  if (!Array.isArray(options) || options.length === 0) return [];
  const match = options.filter(o => o.source === kind || o.source === 'both');
  return match.length > 0 ? match : options;
}

export function recipientsToString(selection) {
  if (!selection) return '';
  const arr = Array.isArray(selection) ? selection : [selection];
  return arr
    .map(o => (typeof o === 'string' ? o : (o && o.email) || ''))
    .filter(Boolean)
    .join(';');
}

export function sourceChipLabel(source) {
  if (source === 'invoice') return 'Invoices';
  if (source === 'general') return 'General';
  if (source === 'both') return 'Invoices + General';
  return '';
}

export function sourceChipColor(source) {
  if (source === 'invoice') return 'primary';
  if (source === 'general') return 'warning';
  if (source === 'both') return 'success';
  return 'grey';
}
